import {withRouter} from 'react-router';

import DefaultForm from '@appComponents/DefaultForm';
import {setDefaultSuccessCallbacks} from '@utils/forms';
import {convertToInt} from '@utils/helpers';
import {getLink} from '@appComponents/Link';

export class SequenceConfigForm extends DefaultForm {
    componentDidMount() {
        setDefaultSuccessCallbacks(this, () => {
            this.props.history.push(getLink('sequenceConfigs.index'));
        });
    }

    prepareDataForSubmit(data) {
        return {
            ...data,
            start_delay: convertToInt(data.start_delay),
            stop_delay: convertToInt(data.stop_delay),
            cutoff: convertToInt(data.cutoff),
        };
    }

    renderCancelButton = () => {
        return null;
    };
}

export default withRouter(SequenceConfigForm);
